/* eslint-disable import/no-cycle */
import { getI18nLanguage } from '@/plugins/i18n'
import { apiHttp } from '../axiosApi'
import { publicFeedback } from '../config/apiRoute'

const publicHeaders = () => ({
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Accept-Language': getI18nLanguage(),
})

/** Lo que la página /l/feedback/:token muestra: pregunta, de qué partido o
 *  club se trata y la respuesta ya guardada (si la hay). 404 token inválido. */
export const getPublicFeedback = async token => apiHttp(
  'GET',
  `${publicFeedback}${token}`,
  {},
  { headers: publicHeaders() },
  false,
  'v3',
)

/** Guarda o actualiza la respuesta. `rating` 1..3 (null = dejar la que
 *  estaba), `comment` opcional. */
export const savePublicFeedback = async (token, rating, comment = null) => apiHttp(
  'PUT',
  `${publicFeedback}${token}`,
  { rating, comment },
  { headers: publicHeaders() },
  false,
  'v3',
)
